export const PAYLOAD_STATUS_APPROVED = "approved"
export const PAYLOAD_STATUS_CHANGE_COMMENT = "changeComment"
export const PAYLOAD_STATUS_DRAFT_CREATED = "draftCreated"
export const PAYLOAD_STATUS_REJECTED = "rejected"
export const PAYLOAD_STATUS_TASK_ADDED = "taskAdded"
export const PAYLOAD_STATUS_TASK_REMOVED = "taskRemoved"
// A removal the editor has since undone. The audit row is kept under this status so a redo can
// revive it, and readers exclude it unless they ask for this status by name.
export const PAYLOAD_STATUS_TASK_REMOVAL_UNDONE = "taskRemovalUndone"

export const SHORT_DESCRIPTION_DRAFT_SUBMITTED = "Draft Submitted"
export const SHORT_DESCRIPTION_DRAFT_REJECTED = "Draft Rejected"
export const SHORT_DESCRIPTION_SCHEDULE_PUBLISHED = "Schedule Published"

export const AUDIT_ORDER_DRAFT_REJECTED = -1
export const AUDIT_ORDER_DRAFT_SUBMITTED = 1
